var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 25,
    height: 25,
    rx: 1.5,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 -4.37114e-08 25)",
    fill: "white",
    stroke: "#E5E5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.04761L12.9524 13L8 17.9524",
    stroke: "#030362"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4763 8.04761L17.4287 13L12.4763 17.9524",
    stroke: "#030362"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMenuIcon);
export default __webpack_public_path__ + "static/media/open-menu-icon.7c3bd81b9dc926f27225a6be3cf77a57.svg";
export { ForwardRef as ReactComponent };